import { render } from "./DraftPosts.vue?vue&type=template&id=18460387"
import script from "./DraftPosts.vue?vue&type=script&lang=js"
export * from "./DraftPosts.vue?vue&type=script&lang=js"

import "./DraftPosts.vue?vue&type=style&index=0&id=18460387&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__